import { useContext as t } from "react";
import { getTableContext as e } from "../TableContext.js";
const m = () => t(e());
export {
  m as useTable
};
